var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvliIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E5E7EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_168_12239",
    transform: "scale(0.011236)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_168_12239",
    width: 89,
    height: 89,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvliIcon);
export default __webpack_public_path__ + "static/media/EvliIcon.e309de3d16d97b06bc121dcfbf0758c9.svg";
export { ForwardRef as ReactComponent };